import CollectionView from "./CollectionView.js";
import Draggable from "./Draggable.js";

class Table extends CollectionView {
    constructor(domElement, options = {}) {
        super(domElement, options);
    }

    createActionsColumn(data, pk) {
        const domElement = document.createElement('td');
        domElement.className = 'table-column table-column-actions';

        if (!!pk) {
            const {contextMenuButtonDomElement, menuDomElement} = this.createActionButtonAndMenu(data, pk);
            domElement.appendChild(contextMenuButtonDomElement);
            domElement.appendChild(menuDomElement);
        }

        return domElement;
    }

    createItemElement(item) {
        const rowDomElement = document.createElement('tr');
        rowDomElement.className = 'table-row';
        rowDomElement.dataset.id = item[this.primaryKeyFieldName] || '';
        rowDomElement.dataset.title = item['$title'] || '';
        rowDomElement.dataset.data = JSON.stringify(item);

        if (this.options.draggable) {
            const dragColumnDomElement = this.findOrCreateDragHandle(rowDomElement, false);
            new Draggable(rowDomElement, {
                movement: 'vertical',
                cloneDraggable: true,
                parent: this.bodyElement,
                dragAnchor: dragColumnDomElement
            });
        }

        if (this.options.checkboxes) {
            const checkboxColumnDomElement = this.findOrCreateCheckboxControl(rowDomElement, false);
            checkboxColumnDomElement.addEventListener('change', this.onCheckedItemsChange.bind(this));
        }

        const headerFieldNames = this.headerFields;
        for (let i = 0; i < headerFieldNames.length; i++) {
            const fieldName = typeof (headerFieldNames[i]) === 'string' ?
                headerFieldNames[i] :
                headerFieldNames[i]['$name'];

            let isHiddenField = false;
            for (let j = 0; j < this.hiddenFieldPatterns.length; j++) {
                if (this.hiddenFieldPatterns[j].exec(fieldName) !== null) {
                    isHiddenField = true;
                    break;
                }
            }

            if (isHiddenField === true) {
                continue;
            }

            const fieldDomElement = document.createElement('td');
            fieldDomElement.className = 'table-column';
            const data = item.hasOwnProperty(fieldName) ?
                item[fieldName] :
                '';

            if (this.renderFunctions.hasOwnProperty(fieldName)) {
                const renderResult = this.renderFunctions[fieldName](data);

                if (renderResult instanceof HTMLElement) {
                    fieldDomElement.appendChild(renderResult);
                } else {
                    fieldDomElement.innerHTML = renderResult;
                }
            } else {
                const stringifiedData = typeof (data) === 'object' ?
                    JSON.stringify(data) :
                    data;

                fieldDomElement.appendChild(document.createTextNode(stringifiedData));
                fieldDomElement.title = stringifiedData;
            }

            rowDomElement.appendChild(fieldDomElement);
        }

        const actionsColumnDomElement = this.createActionsColumn(item,
            item[this.primaryKeyFieldName]);
        rowDomElement.appendChild(actionsColumnDomElement);

        return rowDomElement;
    }
}

export default Table;
